import axios from 'axios';
import sitemap from '../sitemap';
import { GetUrl } from './utilities';

class DocuViewareService {
    static docuviewareGetControl(params) {
        params.theme = document.documentElement.getAttribute("data-theme");
        return axios.post(GetUrl([sitemap.DOCUVIEWARE_CONTROLLER_ROUTE, sitemap.DOCUVIEWARE_GET_CONTROL_ACTION]), params);
    }
};

export default DocuViewareService;